import React, {useContext} from 'react'
import {FormInput, FormDataContext} from '@modifi/plugin-forms'
import {InferPropTypes} from '@modifi/typescript-utils'
import {KEY_JANUS, useTranslation} from '@modifi/plugin-i18n'
import {InputContainer, SelectPure} from '@modifi/ui'
import {LeadExportVolumeCategory, ProductType} from '@modifi/enums'
import * as PropTypes from 'prop-types'

import {RequiredLabel} from '../../styles'

const SelectWithContainer = (props: any) => (
  <InputContainer inputComponent={SelectPure} {...props} />
)

const propTypes = {
  brokerNonce: PropTypes.string.isRequired,
  isBroker: PropTypes.bool.isRequired,
}

const defaultProps = {}

const getLabelTmsKey = (productType: string | undefined): string => {
  switch (productType) {
    case 'Seller finance':
      return `signup.export-volume-category.${ProductType.SELLER_FINANCING}.label`
    case 'Buyer finance':
      return `signup.export-volume-category.${ProductType.BUYER_FINANCING}.label`
    default:
      return 'signup.export-volume-category.label'
  }
}

type ExportVolumeCategoryProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const ExportVolumeCategory: React.FC<ExportVolumeCategoryProps> = ({brokerNonce, isBroker}) => {
  const {t} = useTranslation(KEY_JANUS)
  const {t: pgkFormsT} = useTranslation('pkg:forms')
  const {data} = useContext(FormDataContext)
  const exportVolumeCategoryOptions = Object.values(LeadExportVolumeCategory).map(value => ({
    value,
    label: t(`signup.export-volume-category.option.${value.toLowerCase()}`),
  }))

  return (
    <FormInput
      name="exportVolumeCategory"
      key={brokerNonce}
      inputComponent={SelectWithContainer}
      t={pgkFormsT}
      label={
        <RequiredLabel>{t(getLabelTmsKey(data?.productType as string | undefined))}</RequiredLabel>
      }
      placeholder={t('signup.export-volume-category.placeholder')}
      options={exportVolumeCategoryOptions}
      oneOf={exportVolumeCategoryOptions.map(({value}) => value)}
      optional={isBroker}
      oneOfMessage="tr:error.one-of"
      noBlur
      disabled={isBroker}
    />
  )
}

ExportVolumeCategory.propTypes = propTypes
ExportVolumeCategory.defaultProps = defaultProps

export default ExportVolumeCategory
